module.exports = __webpack_public_path__ + "static/media/bug-report-bg.3227d75d.png";